const HANA = (
    <div className='md:w-4/5 mx-auto py-10 text-lg'>
        <h1 className='text-2xl font-bold'>
        S/4 HANA
        </h1>
        <br />
        <div className='md:px-5 text-gray-500'>
            <p>SAP S/4 HANA is SAP&#39;s next-generation ERP platform. Used primarily by medium and large
                enterprises with at least $250 million in annual revenue, S/4 HANA is built on the SAP HANA in-
                memory database and combines online analytical processing and transaction processing.
            </p>
            <br />
            <p>The combination of single database and parallel processing enables companies to run advanced
                analytics alongside high-speed transactions, as well as receive accurate and up-to-date
                responses in a fraction of a second. It&#39;s ideal for companies that need real-time or near-real-
                time analytics, particularly in industries such as banking, airlines, hospitality and securities. The
                sophistication of the software also makes it a good fit for enterprises with large IT staffs and in-
                house expertise in transaction processing, analytics, applications and database operations.
            </p>
            <br />
            <p>Some of the highlights of SAP S/4 HANA include AI capabilities; machine learning for logistics,
                manufacturing and asset management; and the ability to customize the core system for specific
                industries.
            </p>

        </div>
    </div>
)

export default HANA